import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { UploadService } from './Upload.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class CampaignService extends ApiEvsService {
  constructor(
    http: Http,
    router: Router,
    private uploadService: UploadService
  ) {
    super(http, router);
  }

  all(query?: any) {
    return this.get('/v2/all-campaigns', query);
  }

  list(query?: any) {
    return this.get('/v2/campaigns', query);
  }

  create(body: any) {
    return this.post('/v2/campaigns', body);
  }

  find(id) {
    return this.get('/v2/campaigns/' + id);
  }

  update(id, body) {
    return this.put('/v2/campaigns/' + id, body);
  }

  deleteOne(id) {
    return this.delete('/v2/campaigns/' + id);
  }

  deleteMany(body) {
    return this.post('/v2/delete-campaigns', body);
  }

  listContact(campaign_id, query?: any) {
    return this.get('/v2/campaigns/' + campaign_id + '/contacts', query);
  }

  allContact(query?: any) {
    return this.get('/v2/all-campaign-contacts', query);
  }

  allAgentInQueue(campaign_id, query?: any) {
    return this.get('/v2/campaigns/' + campaign_id + '/allAgents', query);
  }

  createCampaignContact(campaign_id, body) {
    return this.post('/v2/campaigns/' + campaign_id + '/contacts', body);
  }

  deleteCampaignContact(campaign_id, body) {
    return this.post('/v2/campaigns/' + campaign_id + '/delete-contacts', body);
  }

  assignAgentCampaign(query?: any) {
    return this.postServer('/outbound/manual', query);
  }
  getFileImportTicketExample() {
    return this.getexcel('/v2/ticket/export/template', 'FileImportTicketExample');
  }
  importTicket(file, campaign_id, postData?: any) {
    return this.uploadService.postWithFile(
      environment.api_evs + '/v2/ticket/excel/import-data/' + campaign_id,
      file,
      postData
    );
  }
  importContactWithFile(file, campaign_id, postData?: any) {
    return this.uploadService.postWithFile(
      environment.api_evs + '/v2/campaigns/' + campaign_id + '/import-with-file',
      file,
      postData
    );
  }
  importContactWithFilter(campaign_id, body) {
    return this.post('/v2/campaigns/' + campaign_id + '/import-with-filter', body);
  }
  exportCampaign(query: any, body) {
    return this.getexcel('/v2/campaigns/exports', 'DanhSachChienDich', 'POST', query, body);
  }
  exportDetailCampaign(campaign_id, query, body) {
    return this.getexcel('/v2/campaigns/exports/' + campaign_id, 'DanhSachLienHeChienDich', 'POST', query, body);
  }
  getAgentReports(body?: any) {
    return this.post('/v2/campaigns/agent-reports', body);
  }
  exportAgentReports(campaign_id, query, body) {
    return this.getexcel(
      '/v2/campaigns/export-agent-reports/' + campaign_id,
      'BaoCaoChuyenVienChienDich',
      'POST',
      query,
      body
    );
  }
  reAssignAgent(body: any) {
    return this.post('/v2/campaigns/re-assign-agent', body);
  }
  cloneContactCampaign(campaign_id, body: any) {
    return this.post('/v2/campaigns/' + campaign_id + '/clone-contact-from-ticket', body);
  }
  updateGroup(params: any, body: any) {
    const search = new URLSearchParams(params);
    return this.post('/v2/campaigns/updates-group' + `?${search}`, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Campaign.service.ts